import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b446ddec"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b446ddec&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b446ddec')) {
      api.createRecord('b446ddec', component.options)
    } else {
      api.reload('b446ddec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b446ddec", function () {
      api.rerender('b446ddec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjTagList/index.vue"
export default component.exports